export default __webpack_public_path__ + "static/media/profileIcon.25c0f01e.svg";